import React from "react";
import { ITripPlanner } from "../types/plannerTypes";
import { ScheduledTableProps } from "../types/scheduleTypes";
import api from "../../../store/api";
import PlannerTimeline from "./PlannerTimeline";
import { ConflictDialogData } from "../types/conflictNoticeTypes";
import ConflictNotice from "../conflictNotices/ConflictNotice";
import { IVirtualTrip, ITransfer } from "../../../common/plannerTypes";
import TripChangedNotice from "../conflictNotices/TripChangedNotice";
import TransferTable from "../TransferTable";
import { IPlannerState } from "../../../store/modules/plannerSlice";
import { time } from "console";
import { getData, getRoles, persistName, setData } from "../helpers/transferScheduleHelpers";
import { consts } from "../../../common/consts";
import { useSelector } from "react-redux";
import { checkAcuity, checkuserpermission } from "../conflictNotices/conflictNoticeHelper";
import { RootState } from "../../../store/rootReducer";
import { de } from "date-fns/locale";
interface PlannerSectionProps extends ScheduledTableProps {
  selectedLocationId: string;
  selectedDay: string;
  plannerStore: IPlannerState;
  setErrorMessage: any;
  showAdHocRequestModal: any;
  setCurrentTripPlannerId: any | null;
}

const PlannerSection: React.FC<PlannerSectionProps> = (props) => {
  const {
    selectedLocationId,
    selectedDay,
    roles,
    transferMode,
    checks,
    updatedTransfers,
    updateChecks,
    setCurrentTransferId,
    setCurrentBookingId,
    setShowVehicleModal,
    assignToMeClick,
    plannerStore,
    setErrorMessage,
    showAdHocRequestModal,
    setCurrentTripPlannerId,
  } = props;

  const [timelines, setTimelines] = React.useState<ITripPlanner[] | null>(null);

  const [conflictDialogData, setConflictDialogData] = React.useState<ConflictDialogData | null>(null);
  const [userDetails, setUserDetails] = React.useState();
  const[vechiclecount,setvechiclecount] =React.useState(0);
  const getLocationTripPlanners = async () => {
    try {
      setErrorMessage("");
      localStorage.setItem("SelectedLocation", selectedLocationId);
      const res = await api.getLocationTripPlanners("", {
        locationId: selectedLocationId,
        scheduleDate: selectedDay,
      });

      if (res.errorRaised) throw res.errorMessage;
      setTimelines(res.model);
    } catch (error) {
      console.error(error);
      setErrorMessage("Error while getting planners");
    }
  };
  const getVehicles = async (customer: any) => {
    let _loc=customer;
    if(_loc!==undefined && _loc!==null && _loc!==''){
      const res = await api.getVechicles('customerId=' + _loc);
      if (res?.hasError === false) {
          setvechiclecount(res?._result?.length);
      }
    }
  }  
  React.useEffect(() => {
    getLocationTripPlanners();
    getVehicles(authStore.data?.CustomerId);
  }, [selectedLocationId, selectedDay]);

  const isConflictDialogOpen = conflictDialogData !== null;
  const { authStore } = useSelector((state: RootState) => state);
  const [role, setRoles] = React.useState<any>(getRoles(authStore));
  let userper: any = null;
  let userperlist: any = null;
  return (
    <>
      {timelines?.length &&
        timelines.map((tripPlanner, index) => {
          //
          const scheduledTripList: IVirtualTrip[] = plannerStore.visualState.filter(
            (tl: IVirtualTrip) => ((tl.tripPlannerId === tripPlanner.tripPlannerId || tl.tripPlannerId === tripPlanner.sharedPlannerId)
              && new Date(tl.startTrip).getDate() === new Date(selectedDay).getDate() && new Date(tl.startTrip).getMonth() === new Date(selectedDay).getMonth() && new Date(tl.startTrip).getFullYear() === new Date(selectedDay).getFullYear())
          );

          const transfersList: ITransfer[] = [];
          scheduledTripList.forEach((q) => {
            if (q.transfers.length > 1) {
              q.transfers.forEach((el, index) => {
                if (index === 0) {
                  transfersList.push({
                    ...el,
                    scheduleObj: {
                      ...el.scheduleObj,
                      firstInMultiLoad: true,
                    },
                  });
                } else if (index === (q.transfers.length - 1)) {
                  transfersList.push({
                    ...el,
                    scheduleObj: {
                      ...el.scheduleObj,
                      lastInMultiLoad: true,
                    },
                  });
                } else {
                  transfersList.push({
                    ...el,
                    scheduleObj: {
                      ...el.scheduleObj,
                      middleInMultiLoad: true,
                    },
                  });
                }
              });
            } else {
              transfersList.push(...q.transfers);
            }
            if (tripPlanner.sharingRole === null) {
              tripPlanner.sharingRole = consts.Permissions.Primary
            }
            var superuser = (authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMASuperUser));
            if (superuser !== true) {
              if (authStore.data?.IsAdmin || authStore.data?.IsSMAUser) {
                userper = checkuserpermission(tripPlanner.sharingRole, tripPlanner.sharingRole === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
                  some((p) => p == consts.Permissions.SMAViewtransferlist)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMAViewtransferlistSecondary))));
                userperlist = checkuserpermission(tripPlanner.sharingRole, tripPlanner.sharingRole === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
                  some((p) => p == consts.Permissions.SMAViewtransferdetailspage)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.SMAViewtransferdetailspageSecondary))));
              }
              else {
                userper = checkuserpermission(tripPlanner.sharingRole, tripPlanner.sharingRole === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
                  some((p) => p == consts.Permissions.Viewtransferlist)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.ViewtransferlistSecondary))));
                userperlist = checkuserpermission(tripPlanner.sharingRole, tripPlanner.sharingRole === consts.Permissions.Primary ? Boolean(authStore.data?.role.split(",")?.
                  some((p) => p == consts.Permissions.Viewtransferdetailspage)) : (Boolean(authStore.data?.role.split(",")?.some((p) => p == consts.Permissions.ViewtransferdetailspageSecondary))));

              }
            }
          });
          return (
            <React.Fragment key={tripPlanner.tripPlannerId}>
              <PlannerTimeline
                selectedLocationId={selectedLocationId}
                selectedDay={selectedDay}
                plannerStore={plannerStore}
                tripPlanner={tripPlanner}
                setErrorMessage={setErrorMessage}
                setConflictDialogData={setConflictDialogData}
                // blockLabel={timelines.length > 1 ? "ABCDEFG".charAt(index) : null}
                blockLabel={tripPlanner.plannerName ? tripPlanner.plannerName : tripPlanner.plannerNamePlaceholder ? tripPlanner.plannerNamePlaceholder : timelines.length > 1 ? "ABCDEFG".charAt(index) : null}
                showAdHocRequestModal={showAdHocRequestModal}
                roles={roles}
              />
              <TransferTable
                transfers={transfersList.map((q) => q.scheduleObj)}
                transferMode={transferMode}
                updatedTransfers={updatedTransfers}
                checks={checks}
                updateChecks={updateChecks}
                rolesAndFeatures={roles}
                setCurrentTransferId={setCurrentTransferId}
                setCurrentBookingId={setCurrentBookingId}
                setShowVehicleModal={setShowVehicleModal}
                assignToMeClick={assignToMeClick}
                userper={userper}
                userperlist={userperlist}
                setConflictDialogData={setConflictDialogData}
                tripPlanner={tripPlanner}
                setCurrentTripPlannerId={setCurrentTripPlannerId}
                vechiclecount={vechiclecount}
              />
            </React.Fragment>
          );
        })}
      {isConflictDialogOpen ? (
        <ConflictNotice
          isDialogOpen={isConflictDialogOpen}
          onCancel={() => setConflictDialogData(null)}
          conflictType={conflictDialogData!!.conflictType}
          plannerBreakDuration={conflictDialogData?.tripPlanner?.plannerBreakDuration}
          plannerBreakStartTime={conflictDialogData?.tripPlanner?.plannerBreakStartTime}
          plannerMaxBreakDelay={conflictDialogData?.tripPlanner?.plannerMaxBreakDelay}
        />
      ) : null}
      <TripChangedNotice plannerStore={plannerStore} />
    </>
  );
};
export default PlannerSection;
